export const lightTheme = {
    body: '#FFF',
    text: '#363537',
    toggleBorder: '#FFF',
    background: '#FFF',
    backgroundColor: '#FFF',
    cardBg: '#FFFFFF',        // White background for cards
    cardBgHover: '#f8f9fa',  // Very light gray for hover
    borderColor: '#e9ecef',  // Light gray for borders/separators
    imageBg: '#f1f3f5',     // Slightly darker light gray for image background
}
export const darkTheme = {
    body: '#181818',          // Lighter dark background
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
    background: '#181818',    // Matched body
    backgroundColor: '#181818', // Matched body
    cardBg: '#1e1e1e',        // Dark gray for cards
    cardBgHover: '#2a2a2a',  // Slightly lighter dark gray for hover
    borderColor: '#333333',  // Medium dark gray for borders/separators
    imageBg: '#252525',     // Slightly lighter than cardBg for image background
}